import { withLovesListProps } from 'viewModel/content/lovesList/withLovesListProps';
import LovesList from 'components/Content/LovesList/LovesList';

export default withLovesListProps(LovesList);
